import { useLocation } from 'react-router-dom'

export const useSearchParam = (queryName: string) => {
  const location = useLocation()
  const queryObj = new URLSearchParams(location.search)
  return queryObj.get(queryName)
}
